import { render, staticRenderFns } from "./dinnercard.vue?vue&type=template&id=037cc76d&scoped=true&"
import script from "./dinnercard.vue?vue&type=script&lang=js&"
export * from "./dinnercard.vue?vue&type=script&lang=js&"
import style0 from "./dinnercard.vue?vue&type=style&index=0&id=037cc76d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037cc76d",
  null
  
)

export default component.exports